/* eslint-disable @typescript-eslint/no-unsafe-return -- Object.assign with spread requires dynamic types */
export function ensureArray<T>(data: T | T[] | undefined | null): T[] {
  if (data === null || data === undefined) {
    return []
  }
  return Array.isArray(data) ? data : [data]
}

// return a list of objects keyed by a field (usually id)
// for unique only keys
export function arrayByKey<T, K extends keyof T>(
  array: T[],
  field: K,
): Record<string, T> {
  return Object.assign(
    {},
    ...array.map((instance) => ({ [String(instance[field])]: instance })),
  )
}
